import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError} from 'rxjs/operators';

export interface ProcessSeriesPointDto {
  startUtc: string;
  endUtc: string;
  successCount: number;
  failureCount: number;
}

export interface ProcessSeriesDto {
  processName: string;
  windowStartUtc: string;
  windowEndUtc: string;
  resolutionMinutes: number;
  points: ProcessSeriesPointDto[];
}

export interface ProcessWindowStatusDto {
  processName: string;
  windowStartUtc: string;
  windowEndUtc: string;
  successCount: number;
  failureCount: number;
  failureRate: number; // 0..1
  timingStatus: string;
  lastOutcome?: string | null;
  lastSeenUtc?: string | null;
}

@Injectable({ providedIn: 'root' })
export class DataHubMetricsService {
  private readonly basePath = '/api/dmc';

  constructor(private readonly http: HttpClient) {}

  getFetchSeriesAggregate(windowHours = 24, resolutionMinutes = 60): Observable<ProcessSeriesDto | null> {
    const params = new HttpParams()
      .set('windowHours', windowHours)
      .set('resolutionMinutes', resolutionMinutes);
    return this.http.get<ProcessSeriesDto>(`${this.basePath}/DataHubMetrics/getDataHubFetchSeries`, { params }).pipe(catchError(()=> of(null)));
  }

  getSendSeriesAggregate(windowHours = 24, resolutionMinutes = 60): Observable<ProcessSeriesDto | null> {
    const params = new HttpParams()
      .set('windowHours', windowHours)
      .set('resolutionMinutes', resolutionMinutes);
    return this.http.get<ProcessSeriesDto>(`${this.basePath}/DataHubMetrics/getDataHubSendSeries`, { params }).pipe(catchError(()=> of(null)));
  }

  getAggregates(windowHours = 24, warnThresholdFraction?: number, errorThresholdFraction?: number): Observable<ProcessWindowStatusDto[]> {
    let params = new HttpParams().set('windowHours', windowHours);
    if (warnThresholdFraction !== undefined) params = params.set('warnThresholdFraction', warnThresholdFraction);
    if (errorThresholdFraction !== undefined) params = params.set('errorThresholdFraction', errorThresholdFraction);
    return this.http.get<ProcessWindowStatusDto[]>(`${this.basePath}/DataHubMetrics/getDataHubMetrics`, { params }).pipe(catchError(()=> of([])));
  }
}
